import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { IMPRESSION_ACTIONS, SCREEN_NAME } from "../constants";

export const impressionCancellationPolicyWidget = ({
    impressionEvent,
    cartId = "",
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    cartId?: string | number;
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CC_POLICY_CART,
        context: JSON.stringify({ cartId }),
    });
};
